export default __webpack_public_path__ + "static/media/zalando.7bb80f47.jpg";